import { BaseHttpService } from "./BaseHttpService";

interface ISendCodeParams {
  username: string;
  email: string;
  captcha: string;
}

interface ISendCodeResult {
  token: string;
}

interface ICheckCodeParams {
  token: string;
  code: string;
}

export default class EmailService extends BaseHttpService {
  public constructor(readonly url?: string) {
    super(url);
  }

  async sendCode(params: ISendCodeParams): Promise<ISendCodeResult> {
    return await this.post("/v2/email/send-code", params);
  }

  async checkCode(params: ICheckCodeParams): Promise<void> {
    return await this.post("/v2/email/verify-code", params);
  }
}
